import "./main.css";
import { jsxs as b, Fragment as w, jsx as r } from "react/jsx-runtime";
import { useState as O, createContext as Q, useContext as X, useCallback as Z, useEffect as ee, useMemo as S, forwardRef as te, Fragment as ne, useId as pe } from "react";
import { Modal as be, Button as x, Popover as ye, FormGroup as re, ValidatedOptions as I, Select as le, SelectVariant as Ce, SelectOption as ae, Switch as Ie, TextInput as se, TextArea as ve, NumberInput as Te, AlertGroup as Se, Alert as ke, AlertVariant as R, AlertActionCloseButton as xe, InputGroup as oe, ButtonVariant as G, Checkbox as Oe, Radio as Ae, Text as Ne, Title as Ve, Card as qe, CardHeader as we, CardTitle as Le, CardBody as Fe, Grid as _e, GridItem as B, PageSection as Re, JumpLinks as De, JumpLinksItem as Pe } from "@patternfly/react-core";
import { useFormContext as E, Controller as A, useController as ie, FormProvider as Me, useWatch as Ee } from "react-hook-form";
import { HelpIcon as j, CubeIcon as $e, PaypalIcon as He, InstagramIcon as Ge, BitbucketIcon as Be, MicrosoftIcon as je, TwitterIcon as Ue, StackOverflowIcon as Je, OpenshiftIcon as We, LinkedinIcon as Ke, GoogleIcon as ze, GitlabIcon as Ye, FacebookSquareIcon as Qe, GithubIcon as Xe, MinusCircleIcon as Ze, PlusCircleIcon as et } from "@patternfly/react-icons";
import { get as U } from "lodash-es";
const Dt = ({
  modalTitle: e,
  continueLabel: t,
  cancelLabel: n,
  buttonTitle: l,
  isDisabled: a,
  buttonVariant: s,
  buttonTestRole: o,
  onContinue: c,
  component: u = x,
  children: d,
  ...m
}) => {
  const [g, f] = O(!1);
  return /* @__PURE__ */ b(w, { children: [
    /* @__PURE__ */ r(
      u,
      {
        variant: s,
        onClick: () => f(!0),
        isDisabled: a,
        "data-testrole": o,
        children: l
      }
    ),
    /* @__PURE__ */ r(
      be,
      {
        variant: "small",
        ...m,
        title: e,
        isOpen: g,
        onClose: () => f(!1),
        actions: [
          /* @__PURE__ */ r(
            x,
            {
              id: "modal-confirm",
              variant: "primary",
              onClick: () => {
                f(!1), c();
              },
              children: t
            },
            "confirm"
          ),
          /* @__PURE__ */ r(
            x,
            {
              id: "modal-cancel",
              variant: "secondary",
              onClick: () => f(!1),
              children: n
            },
            "cancel"
          )
        ],
        children: d
      }
    )
  ] });
};
function tt(e, t) {
  const n = Q(t);
  return n.displayName = e, n;
}
function nt(e) {
  return e != null;
}
function rt(e) {
  const t = X(e);
  if (nt(t))
    return t;
  throw new Error(
    `No provider found for ${e.displayName ? `the '${e.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`
  );
}
function lt(e, t, n) {
  const [l, a] = O(
    () => e.getItem(t) ?? n
  ), s = Z((o) => {
    a(o), e.setItem(t, o);
  }, []);
  return ee(() => {
    a(e.getItem(t) ?? n), window.addEventListener("storage", o);
    function o(c) {
      c.storageArea === e && (c.key === null || c.key === t) && a(c.newValue ?? n);
    }
    return () => window.removeEventListener("storage", o);
  }, [e, t]), [l, s];
}
function at(e, t, n) {
  const l = S(
    () => JSON.stringify(n),
    [n]
  ), [a, s] = lt(
    e,
    t,
    l
  ), o = S(() => JSON.parse(a), [a]), c = Z(
    (u) => s(JSON.stringify(u)),
    []
  );
  return [o, c];
}
const ce = tt(
  "HelpContext",
  void 0
), st = () => rt(ce), Pt = ({ children: e }) => {
  const [t, n] = at(localStorage, "helpEnabled", !0);
  function l() {
    n(!t);
  }
  return /* @__PURE__ */ r(ce.Provider, { value: { enabled: t, toggleHelp: l }, children: e });
}, ue = ({
  helpText: e,
  fieldLabelId: t,
  noVerticalAlign: n = !0,
  unWrap: l = !1
}) => {
  const { enabled: a } = st();
  return a ? /* @__PURE__ */ r(ye, { bodyContent: e, children: /* @__PURE__ */ b(w, { children: [
    !l && /* @__PURE__ */ r(
      "button",
      {
        "data-testid": `help-label-${t}`,
        "aria-label": t,
        onClick: (s) => s.preventDefault(),
        className: "pf-c-form__group-label-help",
        children: /* @__PURE__ */ r(j, { noVerticalAlign: n })
      }
    ),
    l && /* @__PURE__ */ r(j, { noVerticalAlign: n })
  ] }) }) : null;
}, N = ({
  name: e,
  label: t,
  labelIcon: n,
  error: l,
  children: a,
  ...s
}) => /* @__PURE__ */ r(
  re,
  {
    label: t || e,
    fieldId: e,
    labelIcon: n ? /* @__PURE__ */ r(ue, { helpText: n, fieldLabelId: e }) : void 0,
    helperTextInvalid: l?.message,
    validated: l ? I.error : I.default,
    ...s,
    children: a
  }
), ot = ({
  name: e,
  label: t,
  options: n,
  controller: l,
  variant: a,
  labelIcon: s,
  ...o
}) => {
  const {
    control: c,
    formState: { errors: u }
  } = E(), [d, m] = O(!1);
  return /* @__PURE__ */ r(
    N,
    {
      name: e,
      label: t,
      isRequired: l.rules?.required === !0,
      error: u[e],
      labelIcon: s,
      children: /* @__PURE__ */ r(
        A,
        {
          ...l,
          name: e,
          control: c,
          render: ({ field: { onChange: g, value: f } }) => /* @__PURE__ */ r(
            le,
            {
              ...o,
              toggleId: e.slice(e.lastIndexOf(".") + 1),
              onToggle: (i) => m(i),
              selections: typeof n[0] != "string" ? n.filter((i) => f.includes(i.key)).map((i) => i.value) : f,
              onSelect: (i, h) => {
                if (a === "typeaheadmulti") {
                  const v = h.toString();
                  f.includes(v) ? g(f.filter((k) => k !== v)) : g([...f, v]);
                } else
                  g(h), m(!1);
              },
              onClear: a !== Ce.single ? (i) => {
                i.stopPropagation(), g([]);
              } : void 0,
              isOpen: d,
              variant: a,
              validated: u[e] ? I.error : I.default,
              children: n.map((i) => /* @__PURE__ */ r(
                ae,
                {
                  value: typeof i == "string" ? i : i.key,
                  children: typeof i == "string" ? i : i.value
                },
                typeof i == "string" ? i : i.key
              ))
            }
          )
        }
      )
    }
  );
}, Mt = (e) => {
  const t = e.defaultValue ?? !1, { control: n } = E();
  return /* @__PURE__ */ r(
    N,
    {
      hasNoPaddingTop: !0,
      name: e.name,
      isRequired: e.rules?.required === !0,
      label: e.label,
      labelIcon: e.labelIcon,
      children: /* @__PURE__ */ r(
        A,
        {
          control: n,
          name: e.name,
          defaultValue: t,
          render: ({ field: { onChange: l, value: a } }) => /* @__PURE__ */ r(
            Ie,
            {
              id: e.name,
              "data-testid": e.name,
              label: e.labelOn,
              labelOff: e.labelOff,
              isChecked: e.stringify ? a === "true" : a,
              onChange: (s, o) => {
                const c = e.stringify ? s.toString() : s;
                e.onChange?.(s, o), l(c);
              }
            }
          )
        }
      )
    }
  );
}, $ = te(({ onChange: e, ...t }, n) => /* @__PURE__ */ r(se, { ...t, ref: n, onChange: (a, s) => e?.(s) }));
$.displayName = "TextInput";
const Et = (e) => {
  const { labelIcon: t, ...n } = e, l = !!e.rules?.required, a = e.defaultValue ?? "", { field: s, fieldState: o } = ie({
    ...e,
    defaultValue: a
  });
  return /* @__PURE__ */ r(
    N,
    {
      name: e.name,
      label: e.label,
      labelIcon: t,
      isRequired: l,
      error: o.error,
      children: /* @__PURE__ */ r(
        $,
        {
          isRequired: l,
          id: e.name,
          "data-testid": e.name,
          validated: o.error ? I.error : I.default,
          isDisabled: e.isDisabled,
          ...n,
          ...s
        }
      )
    }
  );
}, H = te(({ onChange: e, ...t }, n) => /* @__PURE__ */ r(ve, { ...t, ref: n, onChange: (a, s) => e?.(s) }));
H.displayName = "TextArea";
const $t = (e) => {
  const t = !!e.rules?.required, n = e.defaultValue ?? "", { field: l, fieldState: a } = ie({
    ...e,
    defaultValue: n
  });
  return /* @__PURE__ */ r(
    N,
    {
      isRequired: t,
      label: e.label,
      labelIcon: e.labelIcon,
      name: e.name,
      error: a.error,
      children: /* @__PURE__ */ r(
        H,
        {
          isRequired: t,
          id: e.name,
          "data-testid": e.name,
          validated: a.error ? I.error : I.default,
          isDisabled: e.isDisabled,
          ...l
        }
      )
    }
  );
}, Ht = ({
  name: e,
  label: t,
  controller: n,
  labelIcon: l,
  ...a
}) => {
  const {
    control: s,
    formState: { errors: o }
  } = E();
  return /* @__PURE__ */ r(
    N,
    {
      name: e,
      label: t,
      isRequired: n.rules?.required === !0,
      error: o[e],
      labelIcon: l,
      children: /* @__PURE__ */ r(
        A,
        {
          ...n,
          name: e,
          control: s,
          render: ({ field: c }) => {
            const u = !!n.rules?.required, d = n.rules?.min, m = c.value === 0 ? n.defaultValue : c.value, g = (f) => c.onChange(d ? Math.max(f, Number(d)) : f);
            return /* @__PURE__ */ r(
              Te,
              {
                ...a,
                id: e,
                value: m,
                validated: o[e] ? I.error : I.default,
                required: u,
                min: Number(d),
                max: Number(n.rules?.max),
                onPlus: () => g(m + 1),
                onMinus: () => g(m - 1),
                onChange: (f) => {
                  const i = Number(f.currentTarget.value);
                  g(isNaN(i) ? n.defaultValue : i);
                }
              }
            );
          }
        }
      )
    }
  );
}, de = Q(void 0), Gt = () => X(de), Bt = ({ children: e }) => {
  const [t, n] = O([]), l = (o) => {
    n((c) => c.filter((u) => u.id !== o));
  }, a = (o, c = R.success, u) => {
    n([
      {
        id: Math.random() * 100,
        message: o,
        variant: c,
        description: u
      },
      ...t
    ]);
  }, s = (o) => {
    a(o, R.danger);
  };
  return /* @__PURE__ */ b(de.Provider, { value: { addAlert: a, addError: s }, children: [
    /* @__PURE__ */ r(Se, { isToast: !0, "data-testid": "alerts", children: t.map(({ id: o, variant: c, message: u, description: d }) => /* @__PURE__ */ r(
      ke,
      {
        isLiveRegion: !0,
        variant: R[c],
        variantLabel: "",
        title: u,
        actionClose: /* @__PURE__ */ r(
          xe,
          {
            title: u,
            onClose: () => l(o)
          }
        ),
        timeout: !0,
        onTimeout: () => l(o),
        children: d && /* @__PURE__ */ r("p", { children: d })
      },
      o
    )) }),
    e
  ] });
}, jt = ({ icon: e }) => {
  const t = it(e);
  return /* @__PURE__ */ r(t, { size: "lg", alt: e });
};
function it(e) {
  switch (e) {
    case "github":
      return Xe;
    case "facebook":
      return Qe;
    case "gitlab":
      return Ye;
    case "google":
      return ze;
    case "linkedin":
    case "linkedin-openid-connect":
      return Ke;
    case "openshift-v3":
    case "openshift-v4":
      return We;
    case "stackoverflow":
      return Je;
    case "twitter":
      return Ue;
    case "microsoft":
      return je;
    case "bitbucket":
      return Be;
    case "instagram":
      return Ge;
    case "paypal":
      return He;
    default:
      return $e;
  }
}
const ct = (e) => {
  try {
    return new Intl.DisplayNames([e], { type: "language" }).of(e);
  } catch {
    return e;
  }
}, ut = ({
  t: e,
  form: t,
  supportedLocales: n
}) => {
  const l = n.map((a) => ({
    key: a,
    value: ct(a) || ""
  }));
  return l.length ? /* @__PURE__ */ r(Me, { ...t, children: /* @__PURE__ */ r(
    ot,
    {
      "data-testid": "locale-select",
      name: "attributes.locale",
      label: e("selectALocale"),
      controller: { defaultValue: "" },
      options: l
    }
  ) }) : null;
}, me = (e) => e?.includes("${"), L = (e) => e.substring(2, e.length - 1), D = (e, t, n) => (me(t) ? e(L(t)) : t) || n, P = (e, t) => D(e, t.displayName, t.name), dt = ["username", "firstName", "lastName", "email"], fe = (e) => e && dt.includes(e), T = (e) => `${fe(e) ? "" : "attributes."}${e?.replaceAll(
  ".",
  "🍺"
)}`, Ut = (e) => e.replaceAll(".", "🍺"), Jt = (e) => e.replaceAll("🍺", ".");
function Wt(e, t, n) {
  (e.responseData.errors !== void 0 ? e.responseData.errors : [e.responseData]).forEach((l) => {
    const a = Object.assign(
      {},
      l.params?.map((s) => n(me(s.toString()) ? L(s) : s))
    );
    t(T(l.field), {
      message: n(l.errorMessage, {
        ...a,
        defaultValue: l.errorMessage || l.field
      }),
      type: "server"
    });
  });
}
function V({
  required: e,
  validators: t
}) {
  return e || mt(t);
}
function mt(e) {
  return e && "length" in e && "min" in e.length && typeof e.length.min == "number" ? e.length.min > 0 : !1;
}
function Kt(e) {
  if (typeof e != "object" || e === null || !("responseData" in e))
    return !1;
  const { responseData: t } = e;
  return J(t) ? !0 : typeof t != "object" || t === null || !("errors" in t) || !Array.isArray(t.errors) ? !1 : t.errors.every(J);
}
function J(e) {
  return !(typeof e != "object" || e === null || !("field" in e) || typeof e.field != "string" || !("errorMessage" in e) || typeof e.errorMessage != "string");
}
const q = ({
  t: e,
  form: t,
  attribute: n,
  renderer: l,
  children: a
}) => {
  const s = n.annotations?.inputHelperTextBefore, {
    formState: { errors: o }
  } = t, c = l?.(n);
  return /* @__PURE__ */ r(
    re,
    {
      label: P(e, n) || "",
      fieldId: n.name,
      isRequired: V(n),
      validated: U(o, T(n.name)) ? "error" : "default",
      helperTextInvalid: e(
        U(o, T(n.name))?.message
      ),
      labelIcon: s ? /* @__PURE__ */ r(ue, { helpText: s, fieldLabelId: n.name }) : void 0,
      children: c ? /* @__PURE__ */ b(oe, { children: [
        a,
        c
      ] }) : a
    },
    n.name
  );
}, ft = ({
  t: e,
  form: t,
  attribute: n,
  renderer: l,
  ...a
}) => /* @__PURE__ */ r(q, { t: e, form: t, attribute: n, renderer: l, children: /* @__PURE__ */ r(
  ht,
  {
    t: e,
    form: t,
    "aria-label": P(e, n),
    name: T(n.name),
    addButtonLabel: e("addMultivaluedLabel", {
      fieldLabel: P(e, n)
    }),
    ...a
  }
) }), ht = ({
  t: e,
  name: t,
  inputType: n,
  form: l,
  addButtonLabel: a,
  isDisabled: s = !1,
  defaultValue: o,
  id: c,
  ...u
}) => {
  const { register: d, setValue: m, control: g } = l, f = Ee({
    name: t,
    control: g,
    defaultValue: o || ""
  }), i = S(() => Array.isArray(f) && f.length !== 0 ? f : o || [""], [f]), h = (y) => {
    F([...i.slice(0, y), ...i.slice(y + 1)]);
  }, v = () => {
    F([...i, ""]);
  }, k = (y, p) => {
    F([...i.slice(0, y), p, ...i.slice(y + 1)]);
  }, F = (y) => {
    const p = y.flatMap((_) => _);
    m(t, p, {
      shouldDirty: !0
    });
  }, ge = n.startsWith("html") ? n.substring(6) : "text";
  return ee(() => {
    d(t);
  }, [d]), /* @__PURE__ */ r("div", { id: c, children: i.map((y, p) => /* @__PURE__ */ b(ne, { children: [
    /* @__PURE__ */ b(oe, { children: [
      /* @__PURE__ */ r(
        se,
        {
          "data-testid": t + p,
          onChange: (_) => k(p, _),
          name: `${t}.${p}.value`,
          value: y,
          isDisabled: s,
          type: ge,
          ...u
        }
      ),
      /* @__PURE__ */ r(
        x,
        {
          "data-testid": "remove" + p,
          variant: G.link,
          onClick: () => h(p),
          tabIndex: -1,
          "aria-label": e("remove"),
          isDisabled: i.length === 1 || s,
          children: /* @__PURE__ */ r(Ze, {})
        }
      )
    ] }),
    p === i.length - 1 && /* @__PURE__ */ b(
      x,
      {
        variant: G.link,
        onClick: v,
        tabIndex: -1,
        "aria-label": e("add"),
        "data-testid": "addValue",
        isDisabled: !y || s,
        children: [
          /* @__PURE__ */ r(et, {}),
          " ",
          e(a || "add")
        ]
      }
    )
  ] }, p)) });
}, W = (e) => {
  const { form: t, inputType: n, attribute: l } = e, a = V(l), s = n.startsWith("multiselect"), o = s ? Oe : Ae, c = l.validators?.options?.options || [], u = l.annotations?.inputOptionLabels;
  return /* @__PURE__ */ r(q, { ...e, children: /* @__PURE__ */ r(
    A,
    {
      name: T(l.name),
      control: t.control,
      defaultValue: "",
      render: ({ field: d }) => /* @__PURE__ */ r(w, { children: c.map((m) => /* @__PURE__ */ r(
        o,
        {
          id: m,
          "data-testid": m,
          label: e.t(L(u?.on || m)),
          value: m,
          isChecked: d.value.includes(m),
          onChange: () => {
            s ? d.value.includes(m) ? d.onChange(
              d.value.filter((g) => g !== m)
            ) : d.onChange([...d.value, m]) : d.onChange([m]);
          },
          readOnly: l.readOnly,
          isRequired: a
        },
        m
      )) })
    }
  ) });
}, K = (e) => {
  const { t, form: n, inputType: l, attribute: a } = e, [s, o] = O(!1), c = V(a), u = l === "multiselect", d = (i, h) => {
    u ? h.value.includes(i) ? h.onChange(h.value.filter((v) => v !== i)) : h.onChange([...h.value, i]) : h.onChange(i);
  }, m = a.validators?.options?.options || [], g = a.annotations?.inputOptionLabels, f = (i) => g ? t(L(g[i])) : i;
  return /* @__PURE__ */ r(q, { ...e, children: /* @__PURE__ */ r(
    A,
    {
      name: T(a.name),
      defaultValue: "",
      control: n.control,
      render: ({ field: i }) => /* @__PURE__ */ r(
        le,
        {
          toggleId: a.name,
          onToggle: (h) => o(h),
          isCreatable: !0,
          onCreateOption: (h) => d(h, i),
          onSelect: (h, v) => {
            const k = v.toString();
            d(k, i), Array.isArray(i.value) || o(!1);
          },
          selections: i.value ? i.value : u ? [] : t("choose"),
          variant: u ? "typeaheadmulti" : "single",
          "aria-label": t("selectOne"),
          isOpen: s,
          isDisabled: a.readOnly,
          required: c,
          children: ["", ...m].map((h) => /* @__PURE__ */ r(
            ae,
            {
              selected: i.value === h,
              value: h,
              children: h ? f(h) : t("choose")
            },
            h
          ))
        }
      )
    }
  ) });
}, gt = (e) => {
  const { form: t, attribute: n } = e, l = V(n);
  return /* @__PURE__ */ r(q, { ...e, children: /* @__PURE__ */ r(
    H,
    {
      id: n.name,
      "data-testid": n.name,
      ...t.register(T(n.name)),
      cols: n.annotations?.inputTypeCols,
      rows: n.annotations?.inputTypeRows,
      readOnly: n.readOnly,
      isRequired: l
    }
  ) });
}, C = (e) => {
  const { form: t, inputType: n, attribute: l } = e, a = V(l), s = n.startsWith("html") ? n.substring(6) : "text";
  return /* @__PURE__ */ r(q, { ...e, children: /* @__PURE__ */ r(
    $,
    {
      id: l.name,
      "data-testid": l.name,
      type: s,
      placeholder: l.annotations?.inputTypePlaceholder,
      readOnly: l.readOnly,
      isRequired: a,
      ...t.register(T(l.name))
    }
  ) });
}, M = {
  text: C,
  textarea: gt,
  select: K,
  "select-radiobuttons": W,
  multiselect: K,
  "multiselect-checkboxes": W,
  "html5-email": C,
  "html5-tel": C,
  "html5-url": C,
  "html5-number": C,
  "html5-range": C,
  "html5-datetime-local": C,
  "html5-date": C,
  "html5-month": C,
  "html5-time": C,
  "multi-input": ft
}, zt = ({
  t: e,
  form: t,
  userProfileMetadata: n,
  supportedLocales: l,
  hideReadOnly: a = !1,
  renderer: s
}) => {
  const o = S(() => {
    if (!n.attributes)
      return [];
    const c = a ? n.attributes.filter(({ readOnly: u }) => !u) : n.attributes;
    return [
      // Insert an empty group for attributes without a group.
      { name: void 0 },
      ...n.groups ?? []
    ].map((u) => ({
      group: u,
      attributes: c.filter(
        (d) => d.group === u.name
      )
    }));
  }, [
    a,
    n.groups,
    n.attributes
  ]);
  return o.length === 0 ? null : /* @__PURE__ */ r(
    Nt,
    {
      label: e("jumpToSection"),
      sections: o.filter((c) => c.attributes.length > 0).map(({ group: c, attributes: u }) => ({
        title: D(e, c.displayHeader, c.name) || e("general"),
        panel: /* @__PURE__ */ b("div", { className: "pf-c-form", children: [
          c.displayDescription && /* @__PURE__ */ r(Ne, { className: "pf-u-pb-lg", children: D(e, c.displayDescription, "") }),
          u.map((d) => /* @__PURE__ */ r(
            pt,
            {
              t: e,
              form: t,
              supportedLocales: l,
              renderer: s,
              attribute: d
            },
            d.name
          ))
        ] })
      }))
    }
  );
}, pt = ({
  t: e,
  form: t,
  renderer: n,
  supportedLocales: l,
  attribute: a
}) => {
  const s = t.watch(
    T(a.name)
  ), o = S(() => yt(a), [a]), c = a.multivalued || It(s) ? M["multi-input"] : M[o];
  return a.name === "locale" ? /* @__PURE__ */ r(
    ut,
    {
      form: t,
      supportedLocales: l,
      t: e,
      attribute: a
    }
  ) : /* @__PURE__ */ r(
    c,
    {
      t: e,
      form: t,
      inputType: o,
      attribute: a,
      renderer: n
    }
  );
}, bt = "text";
function yt(e) {
  if (fe(e.name))
    return "text";
  const t = e.annotations?.inputType;
  return Ct(t) ? t : bt;
}
const Ct = (e) => typeof e == "string" && e in M, It = (e) => Array.isArray(e) && e.length > 1, vt = "_title_1nyfo_2", Tt = {
  title: vt
}, he = ({
  id: e,
  title: t,
  headingLevel: n = "h1",
  size: l = "xl",
  ...a
}) => /* @__PURE__ */ r(
  Ve,
  {
    headingLevel: n,
    size: l,
    className: Tt.title,
    id: e,
    tabIndex: 0,
    ...a,
    children: t
  }
), St = ({
  title: e,
  children: t,
  scrollId: n,
  className: l
}) => {
  const a = pe();
  return /* @__PURE__ */ b(qe, { id: a, className: l, isFlat: !0, children: [
    /* @__PURE__ */ r(we, { className: "kc-form-panel__header", children: /* @__PURE__ */ r(Le, { tabIndex: 0, children: /* @__PURE__ */ r(he, { id: n, title: e }) }) }),
    /* @__PURE__ */ r(Fe, { className: "kc-form-panel__body", children: t })
  ] });
}, kt = (e) => {
  const { title: t, children: n, scrollId: l, ...a } = e;
  return /* @__PURE__ */ r("section", { ...a, style: { marginTop: "var(--pf-global--spacer--lg)" }, children: /* @__PURE__ */ b(w, { children: [
    /* @__PURE__ */ r(he, { id: l, title: t }),
    n
  ] }) });
}, xt = "_panel_cd9gh_1", Ot = "_sticky_cd9gh_5", z = {
  panel: xt,
  sticky: Ot
}, At = "kc-main-content-page-container", Y = (e) => e.replace(/\s+/g, "-"), Nt = ({
  label: e,
  sections: t,
  borders: n = !1,
  ...l
}) => {
  const a = S(
    () => t.filter(({ isHidden: s }) => !s),
    [t]
  );
  return /* @__PURE__ */ b(_e, { hasGutter: !0, ...l, children: [
    /* @__PURE__ */ r(B, { md: 8, sm: 12, children: a.map(({ title: s, panel: o }) => {
      const c = Y(s.toLowerCase());
      return /* @__PURE__ */ r(ne, { children: n ? /* @__PURE__ */ r(
        St,
        {
          scrollId: c,
          title: s,
          className: z.panel,
          children: o
        }
      ) : /* @__PURE__ */ r(kt, { scrollId: c, title: s, children: o }) }, s);
    }) }),
    /* @__PURE__ */ r(B, { md: 4, sm: 12, order: { default: "-1", md: "1" }, children: /* @__PURE__ */ r(Re, { className: z.sticky, children: /* @__PURE__ */ r(
      De,
      {
        isVertical: !0,
        scrollableSelector: `#${At}`,
        label: e,
        offset: 100,
        children: a.map(({ title: s }) => {
          const o = Y(s.toLowerCase());
          return (
            // note that JumpLinks currently does not work with spaces in the href
            /* @__PURE__ */ r(
              Pe,
              {
                href: `#${o}`,
                "data-testid": `jump-link-${o}`,
                children: s
              },
              s
            )
          );
        })
      }
    ) }) })
  ] });
};
export {
  Bt as AlertProvider,
  Dt as ContinueCancelModal,
  St as FormPanel,
  Pt as Help,
  ue as HelpItem,
  jt as IconMapper,
  H as KeycloakTextArea,
  $ as KeycloakTextInput,
  Ht as NumberControl,
  Nt as ScrollForm,
  ot as SelectControl,
  Mt as SwitchControl,
  $t as TextAreaControl,
  Et as TextControl,
  zt as UserProfileFields,
  Ut as beerify,
  tt as createNamedContext,
  Jt as debeerify,
  nt as isDefined,
  Kt as isUserProfileError,
  D as label,
  At as mainPageContentId,
  Wt as setUserProfileServerError,
  Gt as useAlerts,
  st as useHelp,
  rt as useRequiredContext,
  at as useStoredState
};
